<template>
  <div class="border-input" :class="{ active: isInputActive, disabled: disabled }">
    <input
      class="border-input-input"
      type="text"
      ref="input"
      :placeholder="placeholder"
      v-model="value"
      @blur="onInputBlur"
      @click="onInputClick"
      @input="onInputInput"
      :disabled="disabled"
    />
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    initalValue: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "请输入",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data: function () {
    return {
      value: "",
      isInputActive: false,
    };
  },

  created: function () {
    this.value = this.initalValue;
  },

  watch: {
    initalValue(value) {
      this.value = value;
    },
  },

  methods: {
    onInputBlur: function () {
      this.isInputActive = false;
    },

    onInputClick: function () {
      this.isInputActive = true;
    },

    onInputInput: function () {
      this.isInputActive = true;
      this.$emit("onInput", this.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.border-input {
  background-color: white;
  border: 1px solid #dcdfe6;
  border-radius: rem(4);
  height: 100%;
  box-sizing: border-box;
  padding-left: rem(15);
  padding-right: rem(12);
  display: flex;
  align-items: center;
  justify-content: space-between;

  &-input {
    color: black;
    opacity: 0.65;
    font-size: rem(14);
    border: none; // 去除未选中状态边框
    outline: none; // 去除选中状态边框
    flex: 1;
    width: 100%;
  }

  &-input::-webkit-input-placeholder {
    color: #909399;
    font-size: rem(14);
  }
  &-input:disabled {
    color: #999999;
    cursor: not-allowed;
    background-color: #F5F7FA;
  }
}

.border-input.disabled {
  background-color: #F5F7FA;
  border-color: #e8e8e8;
  cursor: not-allowed;
}

.active {
  border: 1px solid #325fac;
}
</style>
